export default {
	GET_PAY_RECORD_LIST: (state, data) => {
		state.payRecord = data
	},
	GET_CASHIER_ORDER_INFO: (state, data) => {
		state.orderInfo = data
	},
	GET_CASHIER_STASTICS_LIST: (state, data) => {
		state.payShopRecord = data
	},
	GET_CASHIER_REPORT: (state, data) => {
		state.payReport = data
	},
}


// WEBPACK FOOTER //
// ./src/store/mp/pay_manage/pay_record/mutations.js